module.exports = __webpack_public_path__ + "img/save.a102a30e.svg";